import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import * as constants from "../../constants";
import naaEligibleFlag from "../../assets/images/naa.png";

const useStyles = makeStyles(theme => ({
  languageInd: {
    border: `${theme.palette.secondary[500]} solid 1px`,
    justifyContent: "center",
    alignItems: "center",
    display: "flex"
  }
}));

function LanguageIndicator(props) {
  const small = props.size === "small";
  const classes = useStyles();
  const size = small ? 18 : 24;
  return (
    <Box
      className={classes.languageInd}
      mr={1}
      width={size}
      height={size}
      lineHeight={2.4}
      fontSize={small ? "0.5rem" : "0.625rem"}
    >
      <Typography color="textSecondary" variant="inherit">
        {props.text}
      </Typography>
    </Box>
  );
}

export default function CourseFlag(props) {
  const { size } = props;
  let flag = props.courseFlag.toLowerCase();
  switch (flag) {
    case constants.flags.english.toLowerCase():
      return <LanguageIndicator text="EN" size={size} />;
    case constants.flags.spanish.toLowerCase():
      return <LanguageIndicator text="ES" size={size} />;
    case constants.flags.naaEligible.toLowerCase():
      return (
        <img
          src={naaEligibleFlag}
          alt="NAA Eligible"
          height={size === "small" ? 14 : 17}
        />
      );
    default:
      return null;
  }
}

CourseFlag.propTypes = {
  courseFlag: PropTypes.string,
  size: PropTypes.oneOf(["default", "small"])
};

CourseFlag.defaultProps = {
  size: "default"
};
